import React, { useMemo } from 'react';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import styles from './scales.module.css';
import ModuleCard from '../moduleCard/ModuleCard';
import DateChip from '../moduleCard/DateChip';
import { formatDate, scaleRecords, summarizeValue, valueColor } from '../../modules/scales/scaleValues';

/**
 * Leitura de uma escala na aba Saúde do paciente: a evolução por data, do
 * registro mais recente ao mais antigo. Some quando a escala não tem registro.
 */
const ScaleHistory = ({ scale, data, collapsible = true }) => {
  const records = useMemo(() => scaleRecords(data, scale.key), [data, scale.key]);
  if (records.length === 0) return null;

  const Icon = scale.icon || TuneOutlinedIcon;

  return (
    <ModuleCard
      accent={scale.accent || 'teal'}
      title={scale.name}
      icon={<Icon />}
      description={scale.description}
      collapsible={collapsible}
    >
      <div className={styles.history}>
        {records.map((record) => {
          const color = valueColor(scale, record.value);
          return (
            <div key={record.id} className={styles.historyRow}>
              <DateChip label={formatDate(record.assessedAt)} compact />
              <span className={styles.historyValue}>
                {color && <span className={styles.dot} style={{ background: color }} />}
                {summarizeValue(scale, record.value)}
              </span>
            </div>
          );
        })}
      </div>
    </ModuleCard>
  );
};

export default ScaleHistory;
